import { formatDate } from 'devextreme/localization';

export class DateHelper {
	static lastDayOfMonth(inputDate) {
		return new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 0);
	}

	static firstDayOfMonth(inputDate) {
		return new Date(inputDate.getFullYear(), inputDate.getMonth(), 1);
	}

	static firstDayOfNextMonth(inputDate) {
		return new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 1);
	}

	static getDaysDifference(date1: Date, date2: Date) {
		// why tf is math.round necessary for dates with same time info?! it is though...
		return Math.round((date1.getTime() - date2.getTime()) / 86400000);
	}

	static getMonthDifference(firstDate: Date, secondDate: Date) {
		return firstDate.getFullYear() * 12 + firstDate.getMonth() - (secondDate.getFullYear() * 12 + secondDate.getMonth());
	}

	static excelDateToJSDate(serial) {
		const utc_days = Math.floor(serial - 25569);
		const utc_value = utc_days * 86400;
		const date_info = new Date(utc_value * 1000);

		const fractional_day = serial - Math.floor(serial) + 0.0000001;

		let total_seconds = Math.floor(86400 * fractional_day);

		const seconds = total_seconds % 60;

		total_seconds -= seconds;

		const hours = Math.floor(total_seconds / (60 * 60));
		const minutes = Math.floor(total_seconds / 60) % 60;

		return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
	}

	static datesEqual(date1: Date, date2: Date) {
		return this.compareDates(date1, date2) === 0;
	}

	static compareDates(date1: Date, date2: Date) {
		if (!date1 && !date2) return 0;
		if (!date1) return -1;
		if (!date2) return 1;
		if (date1.getFullYear() > date2.getFullYear()) return 1;
		if (date1.getFullYear() < date2.getFullYear()) return -1;
		if (date1.getMonth() > date2.getMonth()) return 1;
		if (date1.getMonth() < date2.getMonth()) return -1;
		if (date1.getDate() > date2.getDate()) return 1;
		if (date1.getDate() < date2.getDate()) return -1;
		return 0;
	}

	static withConvertedDates(object) {
		const newObject = {};
		for (const key in object) {
			if (object[key] instanceof Date) {
				// format dates to 'yyyy-MM-dd' per local timezone
				// JSON.stringify will use the UTC date...
				newObject[key] = formatDate(object[key], 'yyyy-MM-dd');
			} else {
				newObject[key] = object[key];
			}
		}
		return newObject;
	}

	// using a very controlled, explicit parsing method because more implicit methods keep screwing up the timezone...
	static parseIsoDate(isodatestring: string, includeTime = false) {
		if (<any>isodatestring instanceof Date) return <Date>(<any>isodatestring);
		if ((isodatestring || '') === '') return new Date(isodatestring);
		const tsplit = isodatestring.split('T');
		const dateparts = tsplit[0].split('-');
		if(includeTime) {
			const timeparts = tsplit[1].split(':');
			return new Date(+dateparts[0], +dateparts[1] - 1, +dateparts[2], +timeparts[0], +timeparts[1], +timeparts[2]);
		}
		return new Date(+dateparts[0], +dateparts[1] - 1, +dateparts[2]);
	}
}
